import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="M30,35 C30,30 35,25 42,25 C50,25 55,29 55,35 L50,35 C50,32 47,29 42,29 C37,29 34,31 34,35 C34,38 36,40 40,41 L47,43 C52,45 56,48 56,54 C56,60 50,64 42,64 C34,64 29,60 29,55 L34,55 C34,58 37,61 42,61 C47,61 51,59 51,55 C51,52 49,50 45,49 L38,47 C33,45 30,42 30,35 Z"
          fill="currentColor"></path>
      </g>
    </g>
  </svg>
);

export default IconLogo;
